export { FixItModule } from "./FixItModule";
export type { FixItModuleProps, FixItProps, FixItStep, FixItRichtext } from "./types";
